var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.308 18c-.505 0-.933-.175-1.283-.525a1.745 1.745 0 01-.525-1.283V4.808c0-.505.175-.933.525-1.283.35-.35.778-.525 1.283-.525h8.384c.505 0 .933.175 1.283.525.35.35.525.778.525 1.283v11.384c0 .505-.175.933-.525 1.283-.35.35-.778.525-1.283.525H9.308zm-3.5 3.5c-.505 0-.933-.175-1.283-.525A1.745 1.745 0 014 19.692V7.558c0-.213.072-.391.215-.535a.726.726 0 01.535-.215c.213 0 .391.072.535.215a.727.727 0 01.215.535v12.134c0 .077.032.148.096.212a.294.294 0 00.212.096h9.134c.213 0 .391.072.535.215a.726.726 0 01.215.535.726.726 0 01-.215.535.726.726 0 01-.535.215H5.808z",
    fill: "currentColor"
  })));
}
SvgCopyFilled.displayName = 'CopyFilled';
export default SvgCopyFilled;